import React from "react";
import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import { PDPGiftCardMessage } from "./PDPGiftCardMessage";
import { FormFieldInputElement } from "./FormFieldInputElement";
import { css } from "@emotion/react";
import { SwarovskiButton } from "../../../../components/_shared-components/ui-elements/SwarovskiButton";
import { MailSvg } from "../../../shop-layouts/checkout-page-layout/CheckoutComponent/shared/form/FormSvgIcons";
import { fontColor, FONTS, fontSize } from "../../../../styles/fonts";
import { ProductAttributeHeadline } from "../pickers/ProductAttributeHeadline";
import { PDPGiftCardProps } from "./usePDPGiftCardProps";
import { T } from "../../../../components/T";

export const PDPGiftCardCustomisation: ReactTFC<PDPGiftCardProps> = props => {
  const {
    giftCardFormEmailPlaceholder,
    giftCardFormFirstNamePlaceholder,
    giftCardFormLastNamePlaceholder,
    giftCardFormMessagePlaceholder,
    giftCardHeadline,
    giftCardMoreInfoLabel,
    giftCardParagraph,
    giftCardRecipientHeadline,
  } = props.translations;

  const { emailFieldDefinition, messageFormDefinition, formState, setFormFieldValue } = props;

  const wrapperStyles = css`
    margin-bottom: 50px;
  `;

  return (
    <>
      <div css={wrapperStyles}>
        <ProductAttributeHeadline headline={giftCardHeadline.value} />
        <PDPGiftCardMessage
          formState={formState}
          setFormFieldValue={setFormFieldValue}
          formDefinition={messageFormDefinition}
        />
      </div>

      <div css={wrapperStyles}>
        <ProductAttributeHeadline headline={giftCardRecipientHeadline.value} />
        <FormFieldInputElement
          formField={emailFieldDefinition}
          value={formState.get(emailFieldDefinition.id) || ""}
          setValue={setFormFieldValue(emailFieldDefinition.id)}
        />
      </div>

      <div css={wrapperStyles}>
        <p css={[FONTS.SwarovskiFutura300, fontColor.black, fontSize.x2]}>
          <T>{giftCardParagraph.value}</T>
        </p>

        {false && (
          <SwarovskiButton
            variant={"plain-underline"}
            as={"a"}
            isInternal={true}
            link={"#"}
            Icon={<MailSvg />}
            iconPosition={"right"}
          >
            <T>{giftCardMoreInfoLabel}</T>
          </SwarovskiButton>
        )}
      </div>
    </>
  );
};
